var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarker = function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 0A4.672 4.672 0 0 0 0 4.667c0 .772.193 1.538.56 2.217l3.851 6.966a.291.291 0 0 0 .51 0l3.853-6.968a4.675 4.675 0 0 0 .56-2.215A4.672 4.672 0 0 0 4.666 0Zm0 7a2.336 2.336 0 0 1-2.334-2.333 2.336 2.336 0 0 1 2.334-2.334A2.336 2.336 0 0 1 7 4.667 2.336 2.336 0 0 1 4.667 7Z",
    fill: "#fff"
  })));
};
export default SvgMarker;